import React, { useEffect, useState } from 'react'
import Tooltip from '@tippyjs/react';


import { getTrans as t } from "../../../../Localization/translations";
import EditContactService from '../../../../services/party/contact/editContactService'
import ContentLoader from 'react-content-loader';
import ContactList from '../../../../components/contactList';
import Helper from '../../../../Helper';

const ContactView = ({setHidecontractListview,hidecontractListview,contactid}) => {
  const [loading, setLoading] = useState(true)
  const [first_name, setFirst_name] = useState("")
  const [last_name, setLast_name] = useState("")
  const [middle_name, setMiddle_name] = useState("")
  const [mobile_number, setMobile_number] = useState("")
  const [phone_number, setPhone_number] = useState("")
  const [status, setStatus] = useState("")
  const [creation_date, setCreation_date] = useState("")
  const [deactivate_date, setDeactivate_date] = useState("")
  const [prefix, setPrefix] = useState("")
  const [email, setEmail] = useState("")
  const handleshowHide = () =>{
		setHidecontractListview(false)

  }
  useEffect(() => {
    EditContactService.getPartyContactDetails(contactid).then(
        (response) => {
          setFirst_name(response.data.first_name)
          setLast_name(response.data.last_name)
          setMiddle_name(response.data.middle_name)
          setMobile_number(response.data.mobile_number)
          setPhone_number(response.data.phone_number)
          setStatus(response.data.status)
          setCreation_date(response.data.creation_date)
          setDeactivate_date(response.data.deactivate_date)
          setEmail(response.data.email)

          setPrefix(response.data.prefix)
            setLoading(false)
        },
    )
}, [contactid])
  return (
      hidecontractListview === true ?
          <div className="panel-content" style={{ paddingLeft: "10px" }}>
              {
                  loading === false ? (
                      <>
                          <div className="header">
                              <h4 className="mb-3 pt-5 tc" onClick={handleshowHide} >{<i className="fa  fa-solid fa-arrow-left"></i>} {t("View Contact")}</h4>
                          </div>
                          <div className="card" role="document">
                              <div className="card-body">
                                  <div className="row">
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label"> {t("Prefix")} <Tooltip content={t("Prefix_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12  view-label p " >
                                                  {prefix}
                                              </p>
                                          </div>
                                      </div>
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label">
                                              {t("First Name")} <Tooltip content={t("FirstName_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                                          </label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12 view-label p " >
                                                  {first_name ? first_name : ""}
                                              </p>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="row">
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label"> {t("Middle name")} <Tooltip content={t("MiddleName_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12  view-label p " >
                                                  {middle_name}
                                              </p>
                                          </div>
                                      </div>
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label">
                                              {t("Last Name")} <Tooltip content={t("LastName_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                                          </label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12 view-label p " >
                                                  {last_name ? last_name : ""}
                                              </p>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="row">
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label"> {t("Email")} <Tooltip content={t("EmailAddress_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12  view-label p " >
                                                  {email}
                                              </p>
                                          </div>
                                      </div>
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label">
                                              {t("Mobile Number")} <Tooltip content={t("MobileNo_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                                          </label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12 view-label p " >
                                                  {mobile_number ? mobile_number : ""}
                                              </p>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="row">
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label"> {t("Phone No")} <Tooltip content={t("PhoneNo_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12  view-label p " >
                                                  {phone_number}
                                              </p>
                                          </div>
                                      </div>
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label">
                                              {t("Status")} <Tooltip content={t("Status_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                                          </label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12 view-label p " >
                                                  {status ? status : ""}
                                              </p>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="row">
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label"> {t("Creation Date")} <Tooltip content={t("CreationDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12  view-label p " >
                                                  {creation_date ? Helper.DateNormal(creation_date) :""}
                                              </p>
                                          </div>
                                      </div>
                                      <div className="col-xl-6 d-flex">
                                          <label className="col-form-label">
                                              {t("Deactivate Date")} <Tooltip content={t("DeActivatedate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                                          </label>
                                          <div className="col-xl-4 d-flex">
                                              <p className="col-lg-12 view-label p " >
                                                  {deactivate_date ? Helper.DatePicker(deactivate_date) : ""}
                                              </p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </>
                  )
                      :
                      (
                          <ContentLoader
                              viewBox="0 0 400 160"
                              backgroundColor="rgba(0,0,0,0.06)"
                              foregroundColor="rgba(0,0,0,0.12)"
                          >
                              <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
                              <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
                              <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
                              <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
                              <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
                              <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
                          </ContentLoader>
                      )
              }
          </div>
          :<ContactList/>
  )
}

export default ContactView